export interface BusinessAttributes {
    isOwner?: boolean;
    typeOfBusiness?: string;
    name: string;
    farmingType: 'conventional' | 'organic' | '';
    businessArea: number | null;
    areaOfArableLand: number | null;
    isdDauerGruen: boolean;
    isAckerbau: boolean;
    isFutterbau: boolean;
    hasDairyCows: boolean;
    countOfDairyCows?: number;
    hasBeef: boolean;
    countOfBeef?: number;
    hasPig: boolean;
    countOfPig?: number;
    hasFowl: boolean;
    countOfFowl?: number;
    hasOtherAnimals: boolean;
    countOfOtherAnimals?: number;
}

export function createEmptyBusinessAttributes(): BusinessAttributes {
    return {
        name: '',
        isOwner: false,
        typeOfBusiness: '',
        farmingType: '',
        businessArea: null,
        areaOfArableLand: null,
        isdDauerGruen: false,
        isAckerbau: false,
        isFutterbau: false,
        hasDairyCows: false,
        countOfDairyCows: null,
        hasBeef: false,
        countOfBeef: null,
        hasPig: false,
        countOfPig: null,
        hasFowl: false,
        countOfFowl: null,
        hasOtherAnimals: false,
        countOfOtherAnimals: null
    };
}